import { Box, Typography } from '@mui/material';
import React from 'react';

export const MatchingPropLeadFieldSelectShow = ({ property }) => {
  const { publicLabel, minValue, options, label } = property;

  const selectedOption = options.find((obj) => obj.value === minValue);

  return (
    <Box className="flex items-start justify-between gap-2">
      <Typography>{`${publicLabel || label}: `}</Typography>
      <Typography>{`${selectedOption?.label || '-'}`}</Typography>
    </Box>
  );
};
